import { useIntl } from 'react-intl';
import {
    FilterItem,
    Filters,
    PeriodSelectorFilter,
    RadioGroupFilter,
    SearchFilter,
    ToggleFilter,
} from '@tlx/astro-shared';
import { Filter, FilterState } from '@Component/Filter/utils';

import { DateDivisionType } from '@tlx/atlas';

interface Props {
    filterState: FilterState; // define filterState in Props
}

export function OverviewFilters({ filterState }: Props) {
    const intl = useIntl();

    /** see https://tripletex.slack.com/archives/C01RY0B58LE/p1719995416418079
     * for a reason why it is done this way (very quickly before a release of a pilot)
     * Also didnt want to copy the filters twice, but <Filters> doesnt accept children other than filters
     * so was not able to make it generic by passing in the children to both <Filters> vs <div className="tsk-filter-bar">
     */
    const showToggleReversal = filterState.contentFilter.query === ''; //only show when salary, and salary is default so empty string

    return (
        <Filters>
            <SearchFilter {...filterState.searchFilter} />
            <PeriodSelectorFilter
                {...filterState.periodFilter}
                className={getClassNamePeriodFilterWidth(filterState.periodFilter)}
                divisions={['Year', 'WageTerm', 'Month']}
                defaultValue={
                    filterState.periodFilter.defaultValue
                        ? [filterState.periodFilter.defaultValue[0], filterState.periodFilter.defaultValue[1]]
                        : undefined
                }
                defaultType={filterState.periodFilter.defaultValue?.[2] as DateDivisionType}
            />
            <RadioGroupFilter {...filterState.contentFilter} defaultValue="salary-payment">
                <FilterItem value="salary-payment">
                    {intl.formatMessage({
                        id: 'text_wage_payment',
                    })}
                </FilterItem>
                <FilterItem value="pension">
                    {intl.formatMessage({
                        id: 'text_pension',
                    })}
                </FilterItem>
                <FilterItem value="reimbursement">
                    {intl.formatMessage({
                        id: 'text_sick_payable',
                    })}
                </FilterItem>
            </RadioGroupFilter>
            {showToggleReversal && <ToggleFilter {...filterState.excludeReversedFilter} defaultChecked />}
        </Filters>
    );
}

function getClassNamePeriodFilterWidth(periodFilter: Filter) {
    const string = periodFilter.query ? periodFilter.query : (periodFilter.defaultValue?.join(',') ?? '');

    //some edgecases counts as months/years, but should be full width as they are not a single month/year
    //example is Desember 2024 - January 2025 which counts as a month, but it is multiple months and takes up space
    const splitString = string.split(',');
    const multiple =
        splitString.length >= 2 && new Date(splitString[0]).getMonth() !== new Date(splitString[1]).getMonth();

    if (string.includes('Month')) {
        if (multiple) {
            return 'atl-w-full';
        }
        return 'tsk-period-selector--width__month';
    }

    if (string.includes('Year')) {
        if (multiple) {
            return 'atl-w-full';
        }

        return 'tsk-period-selector--width__year';
    }

    return '';
}
